import { IOffer } from '../../../types/offer';

export function getCommercialPromoTitle(offer: IOffer): string | undefined {
  return offer.title?.trim() || undefined;
}
